export const ATTENDANCE_PRESENT = 1;
export const ATTENDANCE_ABSENT = 2;

export const attendanceWritesEnabled = (value) => value === "true";

export const availableStudentIds = (rows) =>
  Array.from(
    new Set(
      (Array.isArray(rows) ? rows : [])
        .map((row) => Number(row?.student_id))
        .filter((studentId) => Number.isInteger(studentId) && studentId > 0)
    )
  );

export const buildAttendanceWritePayload = ({
  date,
  lectureId,
  state,
  selectedIds,
  rows,
}) => {
  if (state !== ATTENDANCE_PRESENT && state !== ATTENDANCE_ABSENT) {
    throw new Error("Unsupported attendance state");
  }

  const normalizedLectureId = Number(lectureId);
  if (!Number.isInteger(normalizedLectureId) || normalizedLectureId <= 0) {
    throw new Error("Invalid lecture ID");
  }

  const available = new Set(availableStudentIds(rows));
  const studentIds = Array.from(
    new Set(
      Array.from(selectedIds || [])
        .map(Number)
        .filter((studentId) => available.has(studentId))
    )
  );

  if (studentIds.length === 0) {
    throw new Error("No available students selected");
  }

  return {
    date,
    lectureId: normalizedLectureId,
    state,
    studentIds,
  };
};
